// Sólo el booleano del colegio habilita academias; preservar grupos compartidos.
export const permiteOmitir = (horario, esAcademia) =>
  horario?.BloqueCompartido === true || esAcademia === true;
